import { createTitleBarNudgeStore } from '@frontend/shell-utils';

export const useTitleBarNudgeStore = createTitleBarNudgeStore();
